import styled from '@emotion/styled'
import { Box } from '@gousto-internal/citrus-react'

export const ImageContainer = styled(Box)({
  img: {
    width: '100%',
  },
})
